function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "slack-technologies-vector-logo",
  transform: "translate(-20.2 -245.9)"
}, React.createElement("path", {
  id: "Path_1093",
  "data-name": "Path 1093",
  d: "M208.7,270.047l1.358-3.181a9.113,9.113,0,0,0,5.357,1.674c1.414,0,2.325-.558,2.325-1.4-.037-2.325-8.556-.521-8.631-6.38-.037-2.976,2.623-5.283,6.362-5.283a9.861,9.861,0,0,1,6.045,1.8l-1.265,3.237a9.563,9.563,0,0,0-4.966-1.581c-1.172,0-1.935.558-1.935,1.265.037,2.307,8.631,1.042,8.724,6.641,0,3.051-2.586,5.171-6.269,5.171a11.869,11.869,0,0,1-7.106-1.972m54.036-4.315a3.943,3.943,0,1,1,0-3.869l3.776-2.1a8.277,8.277,0,1,0,0,8.073Zm-38.206,5.99h4.725v-23.1h-4.725Zm44.363-23.1v23.1h4.725V264.8l5.6,6.92h6.027l-7.106-8.222,6.585-7.682h-5.766l-5.338,6.38V248.6h-4.725Zm-25.111,7.217v1.879a5.542,5.542,0,0,0-4.687-2.195c-4.129,0-7.4,3.664-7.4,8.259s3.255,8.3,7.4,8.3a5.59,5.59,0,0,0,4.687-2.195v1.879h4.725v-15.9h-4.725Zm0,9.914a4.327,4.327,0,0,1-3.683,1.972,3.943,3.943,0,0,1,0-7.887,4.3,4.3,0,0,1,3.683,2.046Z",
  transform: "translate(-153.437 -2.198)"
}), React.createElement("path", {
  id: "Path_1094",
  "data-name": "Path 1094",
  d: "M30.338,246a2.772,2.772,0,1,0,0,5.543h2.772v-2.772A2.767,2.767,0,0,0,30.338,246m0,7.385H22.972a2.772,2.772,0,0,0,0,5.543h7.385a2.772,2.772,0,1,0-.019-5.543",
  transform: "translate(0 -0.081)",
  fill: "#36c5f0"
}), React.createElement("path", {
  id: "Path_1095",
  "data-name": "Path 1095",
  d: "M112.428,256.075a2.772,2.772,0,0,0-5.543,0v2.772h2.772a2.755,2.755,0,0,0,2.772-2.772m-7.385,0v-7.4a2.772,2.772,0,1,0-5.543,0v7.4a2.779,2.779,0,0,0,2.772,2.772,2.743,2.743,0,0,0,2.772-2.772",
  transform: "translate(-64.549 0)",
  fill: "#2eb67d"
}), React.createElement("path", {
  id: "Path_1096",
  "data-name": "Path 1096",
  d: "M102.272,338.446a2.772,2.772,0,1,0,0-5.543H99.5v2.772a2.779,2.779,0,0,0,2.772,2.772m0-7.4h7.385a2.772,2.772,0,1,0,0-5.543h-7.385a2.772,2.772,0,1,0,0,5.543h0",
  transform: "translate(-64.549 -64.794)",
  fill: "#ecb22e"
}), React.createElement("path", {
  id: "Path_1097",
  "data-name": "Path 1097",
  d: "M20.2,328.272a2.778,2.778,0,0,0,2.772,2.772h0a2.778,2.778,0,0,0,2.772-2.772V325.5H22.972a2.767,2.767,0,0,0-2.772,2.772m7.385,0v7.4a2.772,2.772,0,1,0,5.543,0v-7.4a2.778,2.778,0,0,0-2.772-2.772h0a2.767,2.767,0,0,0-2.772,2.772",
  transform: "translate(0 -64.794)",
  fill: "#e01e5a"
}));

const SvgSlackFullLogo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 111.606 27.753",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSlackFullLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/slack_full_logo.89885434.svg";
export { ForwardRef as ReactComponent };